import { useContext, useEffect, useState } from "react";
import { AppCtx } from "src/contexts/app.context";

interface AlgoliaIndex {
  indexName: string;
  sortBy?: string;
  defaultSort?: string;
}

/**
 * @deprecated
 * @param indexName
 * @param sortBy
 * @param defaultSort
 */
const useAlgoliaIndex = ({
  indexName,
  sortBy,
  defaultSort,
}: AlgoliaIndex): string => {
  const { isGhostDomain, locale } = useContext(AppCtx);
  const prefix = isGhostDomain ? "zz" : locale;
  const [index, setIndex] = useState<string>("");

  useEffect(() => {
    if (sortBy) {
      setIndex(
        sortBy === "popular"
          ? `${prefix}_${indexName}`
          : `${prefix}_${indexName}${sortBy}`
      );
    } else {
      setIndex(
        defaultSort
          ? `${prefix}_${indexName}${defaultSort}`
          : `${prefix}_${indexName}`
      );
    }
  }, [defaultSort, indexName, prefix, sortBy]);

  return index;
};

export default useAlgoliaIndex;
